export default __webpack_public_path__ + "static/media/formosan-3.f713b7d1.jpg";